import { useLayoutEffect, useState } from 'react';
import { useTheme } from 'styled-components';

const useCompatibleDisplay = () => {
  const { _breakpoints } = useTheme();

  const [size, setSize] = useState({
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    innerWidth: window.innerWidth,
  });
  const mobileSize = _breakpoints[0];
  const tabletSize = _breakpoints[1];
  const largeTabletSize = _breakpoints[2];

  const updateSize = () => {
    setSize({
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      innerWidth: window.innerWidth,
    });
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const screenWidth = size.screenWidth;
  const screenHeight = size.screenHeight;
  const innerWidth = size.innerWidth;

  const isMobile = innerWidth <= mobileSize;
  const isTablet = innerWidth <= tabletSize;
  const isLargeTablet = innerWidth <= largeTabletSize;
  const isCompatibleMobile = screenWidth <= mobileSize || screenHeight <= mobileSize;

  return { isMobile, isTablet, isLargeTablet, isCompatibleMobile };
};

export default useCompatibleDisplay;
